import { Component, computed, inject } from '@angular/core';
import { PackageService } from '@lib/package/package.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, of } from 'rxjs';
import { DashboardStatsCardComponent } from '../../../components/dashboard-stats-card/dashboard-stats-card.component';

@Component({
    selector: 'app-count-provider-owned-packages',
    imports: [
        DashboardStatsCardComponent
    ],
    templateUrl: './count-provider-owned-packages.component.html',
    standalone: true,
    styleUrl: './count-provider-owned-packages.component.scss'
})
export class CountProviderOwnedPackagesComponent {

    private readonly _packageService = inject(PackageService);
    protected readonly Number = Number;

    providerOwnedCountResult = toSignal(
        this._packageService.getProviderOwnedPackageCount().pipe(
            catchError(() => of(null))
        )
    );

    providerOwned = computed(() => this.providerOwnedCountResult()?.count);

    getPackageCount(): number {
        return this.providerOwned() && Number(this.providerOwned()) > 0 ? Number(this.providerOwned()) : 0;
    }
}
